// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@steiner/App/SharedStyles/CartLineSharedStyles";
import { quickOrderProductListStyles } from "@steiner/Overrides/Widgets/QuickOrder/QuickOrderProductList";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

quickOrderProductListStyles.container = {
    css: css`
        padding-top: 12px;
        margin-top: 12px;
        border-top: 1px solid ${color("common.border")};
        ${xScreen("lte", "md")} {
            border-top: 0;
            padding-top: 0;
        }
    `,
};

quickOrderProductListStyles.wrapper = {
    css: css`
        ${xScreen("lte", "md")} {
            border-top: 2px solid ${color("primary")};
        }
    `,
};

quickOrderProductListStyles.noProductListWrapper = {
    css: css`
        padding-top: 12px;
        margin-top: 12px;
        border-top: 1px solid ${color("common.border")};
    `,
};

quickOrderProductListStyles.notifyMsg = {
    css: css`
        max-width: 100%;
    `,
};

quickOrderProductListStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

quickOrderProductListStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

quickOrderProductListStyles.productNumber = {
    ...cartLineSharedStyles.productPartNumbers,
};

quickOrderProductListStyles.availability = {
    ...cartLineSharedStyles.productAvailability,
};

quickOrderProductListStyles.price = {
    ...cartLineSharedStyles.productPrice,
};

quickOrderProductListStyles.priceTotal = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

quickOrderProductListStyles.removeProductIcon = {
    ...cartLineSharedStyles.removeCartLineIcon,
};

quickOrderProductListStyles.qtyFieldStyles = {
    labelText: {
        css: css`
            ${xScreen("gt", "lg")} {
                display: none;
            }
        `,
    },
};

quickOrderProductListStyles.addToListLink = {
    link: {
        ...cartLineSharedStyles.addToListLink,
    },
};
